import { useEffect, useState } from 'react';

/**
 * Converts a File object into a Data URL using FileReader.readAsDataURL.
 * Returns a base64-encoded data URL that can be used directly as an image source.
 * Compatible with Ant Design Image component and consistent with server-loaded labels.
 */
export const useObjectUrl = (file: File | null): string | null => {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!file) {
      setUrl(null);

      return;
    }

    const reader = new FileReader();

    reader.onloadend = () => {
      if (typeof reader.result === 'string') {
        setUrl(reader.result);
      } else {
        setUrl(null);
      }
    };

    reader.onerror = () => {
      setUrl(null);
    };

    reader.readAsDataURL(file);

    return () => {
      reader.abort();
    };
  }, [file]);

  return url;
};
